<template>
	<Transition name="welcome-fade">
		<div v-if="welcomeData" class="event-welcome-overlay" @click="dismiss">
			<div class="event-welcome-content">
				<div class="event-welcome-icon">
					<i class="fas fa-check-circle"></i>
				</div>
				<h2 class="event-welcome-title">Bienvenido/a</h2>
				<h3 class="event-welcome-name">{{ welcomeData.userName }}</h3>
				<p v-if="welcomeData.eventName" class="event-welcome-event">{{ welcomeData.eventName }}</p>
				<p v-if="welcomeData.registrationType" class="event-welcome-type">{{ welcomeData.registrationType }}</p>
				<p class="event-welcome-hint">Toca para cerrar</p>
			</div>
		</div>
	</Transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "EventWelcomeOverlay",
	data() {
		return {
			autoDismissTimer: null,
		};
	},
	computed: {
		...mapGetters("wePass", ["eventWelcome"]),
		welcomeData() {
			return this.eventWelcome;
		},
	},
	watch: {
		welcomeData(newVal) {
			if (newVal) {
				this.scheduleAutoDismiss();
			}
		},
	},
	beforeUnmount() {
		this.clearAutoDismiss();
	},
	methods: {
		scheduleAutoDismiss() {
			this.clearAutoDismiss();
			this.autoDismissTimer = setTimeout(() => {
				this.dismiss();
			}, 5000);
		},
		clearAutoDismiss() {
			if (this.autoDismissTimer) {
				clearTimeout(this.autoDismissTimer);
				this.autoDismissTimer = null;
			}
		},
		dismiss() {
			this.clearAutoDismiss();
			this.$store.commit("wePass/clearEventWelcome");
		},
	},
};
</script>

<style scoped>
.event-welcome-overlay {
	position: fixed;
	inset: 0;
	z-index: 10000;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(135deg, rgba(40, 167, 69, 0.95) 0%, rgba(25, 135, 84, 0.95) 100%);
	cursor: pointer;
}

.event-welcome-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.5rem;
	text-align: center;
	color: #fff;
	padding: 2rem;
}

.event-welcome-icon {
	font-size: 3rem;
	margin-bottom: 0.5rem;
	animation: welcome-bounce 0.6s ease-out;
}

.event-welcome-title {
	font-size: 1.5rem;
	font-weight: 400;
	margin: 0;
	opacity: 0.9;
}

.event-welcome-name {
	font-size: 2rem;
	font-weight: 700;
	margin: 0;
}

.event-welcome-event {
	font-size: 1rem;
	opacity: 0.85;
	margin: 0;
}

.event-welcome-type {
	display: inline-block;
	padding: 0.25rem 0.75rem;
	border-radius: 1rem;
	background: rgba(255, 255, 255, 0.2);
	font-size: 0.875rem;
	font-weight: 600;
	margin: 0;
}

.event-welcome-hint {
	font-size: 0.75rem;
	opacity: 0.6;
	margin-top: 1rem;
}

/* Transition */
.welcome-fade-enter-active {
	transition: opacity 0.4s ease;
}

.welcome-fade-leave-active {
	transition: opacity 0.3s ease;
}

.welcome-fade-enter-from,
.welcome-fade-leave-to {
	opacity: 0;
}

/* Bounce animation for the check icon */
@keyframes welcome-bounce {
	0% {
		transform: scale(0);
		opacity: 0;
	}
	60% {
		transform: scale(1.2);
		opacity: 1;
	}
	100% {
		transform: scale(1);
	}
}
</style>
